import {AlertType} from "../../interfaces/IAlert";
<template>
  <v-container class="login-container" fill-height fluid>
    <div class="login-background">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 1903 556"
      >
        <path
          class="svg-banner-shape"
          d="M753.1,434.2c110.6,63.7,277.7,70.6,373.4,15.4L1905,0v555.9H0V0.2L753.1,434.2z"
        ></path>
      </svg>
    </div>
    <v-row align="center" justify="center" style="z-index: 10">
      <v-col cols="11" sm="7" md="5" lg="4" xl="3">
        <div class="logo text-center mb-12 font-weight-medium">
          <img :src="'/admin/assets/img/logos/homelogo.png'" />
        </div>
        <v-card>
          <template v-if="this.user">
            <v-card-title class="display-1 justify-center font-weight-medium">{{
              $t('resetPassword.title')
            }}</v-card-title>
            <v-card-subtitle class="pt-2">{{
              $t('resetPassword.subtitle')
            }}</v-card-subtitle>
            <v-card-text>
              <v-form @submit.prevent v-model="valid">
                <v-text-field
                  v-model="password"
                  name="password"
                  :rules="$rule('required|min6|max64')"
                  :label="$t('password')"
                  type="password"
                  outlined
                  dense
                  prepend-inner-icon="lock"
                ></v-text-field>
                <v-text-field
                  v-model="rPassword"
                  name="passwordRepeat"
                  :rules="[
                    (v) => v === password || $t('signup.passwordsDontMatch'),
                  ]"
                  @keypress.enter="send"
                  :label="$t('signup.repeatPassword')"
                  type="password"
                  outlined
                  dense
                  prepend-inner-icon="lock_outline"
                ></v-text-field>
                <div class="text-center mt-6">
                  <v-btn
                    class="d-block col-12"
                    color="primary"
                    depressed
                    large
                    @click="send"
                    :disabled="!valid"
                    :loading="loading"
                    >{{ $t('change') }}</v-btn
                  >
                </div>
              </v-form @submit.prevent>
            </v-card-text>
          </template>
          <template v-else>
            <v-card-text>
              <p class="mb-0 grey--text">
                {{ $t('resetPassword.invalid') }}
              </p>
            </v-card-text>
          </template>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
  import { Component, Vue } from 'vue-property-decorator';
  import { vueData } from '../../VueData';
  import AuthService from '../../api/services/auth.service';
  import { AlertType } from '../../interfaces/IAlert';
  import { IUser } from '../../interfaces/IUser';

  @Component
  export default class ResetPassword extends Vue {
    authService = new AuthService();
    password: string = null;
    rPassword: string = null;
    loading: boolean = false;
    sent: boolean = false;
    valid: boolean = false;
    user: IUser = null;

    async created() {
      if (this.token)
        this.user = await this.authService.getUserByForgotToken(
          this.token as string
        );
    }

    get token() {
      return this.$route.query.token;
    }

    async send() {
      this.loading = true;

      try {
        await this.authService.resetPassword(
          this.token as string,
          this.password
        );
        vueData.addAlert(this.$tc('resetPassword.success'), AlertType.Success);
        this.$router.push('/login');
      } catch (e) {
        console.error(e);
        vueData.serverError(e);
      } finally {
        this.loading = false;
      }
    }
  }
</script>
